import { FC, ReactNode } from "react";
import { Box, useTheme, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface SidebarLayoutProps {
  children?: ReactNode;
}
const HeaderBlock = styled(Box)(
  ({ theme }) => `
   position: -webkit-sticky; /* For Safari support */
  position: sticky;
  top: 0;
  z-index: 1000; /* Ensures it's on top */
  background: ${theme.header.background};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`
);

const FooterBlock = styled(Box)(
  ({ theme }) => `
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #F9F8F8;
    color: white;
    text-align: center;
    padding-top: 16px;
    padding-bottom: 16px;
    color:#2C2B2B;
    
`
);

const ContentBlock = styled(Box)(() => ({
  height: "max-content",
  padding: "20px 20px 60px 20px",
}));

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();

  return (
    <>
      <Box>
        <Sidebar />
        <Box
          sx={{
            [theme.breakpoints.up("lg")]: {
              ml: `${theme.sidebar.width}`,
            },
          }}
        >
          <HeaderBlock display="block">
            <Header />
          </HeaderBlock>
          <ContentBlock display="block">
            <Outlet />
          </ContentBlock>
          <FooterBlock>
            <Typography variant="body2">
              Copyright © {new Date().getFullYear()}{" "}
              <a href="www.savicloud.com" target="_blank">
                Savi
              </a>
              . All rights reserved.
            </Typography>
          </FooterBlock>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
